module.exports = __webpack_public_path__ + "static/media/AMR horizontal.fc1bab3e.png";